import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { downloadAppURL } from "../App"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function DownloadApp() {
  const [isMobile, setIsMobile] = useState(false)
  const handleDownload = () => {
    window.location.href = downloadAppURL
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Android App - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Download the FGH Android app to play live blackjack, slots & sports betting anytime. Easy mobile access, fast payouts & GCash/Maya support. 21+ only."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <div className="main-body-content main-container-global-adjusted-padding download-app-content">
        <div className="download-app-content--content">
          <div>
            <h1>Get the FGH Mobile App</h1>
            <div className="download-app-character">
              <img
                className="download-asset"
                src="/images/character/FGH_DOWNLOAD_ASSET_APP.webp?v=2.0"
                alt="FGH Android app download QR code poster"
              />
              <div className="download-app-btn">
                <img
                  src="/images/character/FGH_DOWNLOAD_BTN.webp"
                  alt="FGH Download App Button"
                  onClick={handleDownload}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="download-app-content--app">
          <p>
            FGH, your one stop online gaming platform is now available at the
            palm of your hand.
          </p>
          <p>
            Enjoy your favourite games from FGH in fullscreen, directly on your
            mobile device anywhere, anytime.
          </p>
          <p>What are you waiting for? Download the FGH mobile app now.</p>
        </div>
      </div>
    </>
  )
}
